module.exports = __webpack_public_path__ + "static/media/icon_credit_card.90dfeab5.png";